import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Container, Form } from "react-bootstrap";
import FormControl from '@mui/material/FormControl';
import { FormHelperText, TextField } from "@mui/material";
import toast from "react-hot-toast";

import ModalTemplate from "../../../components/modal/modalTemplate";
import { theme } from "../../../theme";
import BtnSpinner from "../../../components/btnSpinner";
import Context from "../context";
import { updateSkillJobNeedTime } from "../service";

const SkillsJobNeedTime = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const context = useContext(Context);
    const { state, dispatch } = context;
    const { show_skills_job_need_time, selected_skills } = state;

    const [loading, setLoading] = useState(false);

    // 👇 Reset form whenever selected_skills changes
    useEffect(() => {
        if (selected_skills) {
            reset({
                description: selected_skills.skill_job_needs_time_description || "",
            });
        }
    }, [selected_skills, reset]);

    const closeModal = () => {
        dispatch({
            type: 'IS_SHOW_SKILLS_JOB_NEED_TIME',
            show_skills_job_need_time: false,
            selected_skills: {}
        });
        reset();
    };

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            const response = await updateSkillJobNeedTime(selected_skills.skill_id, data.description);
            if (response.status === "Success") {
                setLoading(false);
                dispatch({ type: 'REFRESH' });
                toast.success(response.message);
                closeModal();
            } else {
                dispatch({
                    type: 'SET_ERROR',
                    error: response.message
                });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    return (
        <ModalTemplate
            show={show_skills_job_need_time}
            closeFun={closeModal}
            size={null}
            centered={false}
            title="How much typical job needs time"
            body={
                <Container>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <FormControl error={!!errors.description} fullWidth>
                            <TextField
                                error={!!errors.description}
                                multiline
                                rows={4}
                                sx={{ backgroundColor: '#fff' }}
                                placeholder="Description"
                                {...register("description", { required: true })}
                            />
                            {errors.description && <FormHelperText>Description is required</FormHelperText>}
                        </FormControl>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button
                                variant={theme.close_btn}
                                onClick={closeModal}
                                size="sm"
                                disabled={loading}
                            >
                                {loading ? <BtnSpinner /> : 'CLOSE'}
                            </Button>
                            <Button
                                variant={theme.action_btn}
                                type="submit"
                                size="sm"
                                disabled={loading}
                            >
                                {loading ? <BtnSpinner /> : 'SAVE'}
                            </Button>
                        </div>
                    </Form>
                </Container>
            }
        />
    );
};

export default SkillsJobNeedTime;